import React from 'react'
import PartnerSubscriptionExpiredPageNav from '../../components/Navbar/PartnerSubscriptionExpiredPageNav'
import PartnerPricing from './PartnerPricing'

const PartnerSubscriptionExpired = () => {
  return (
    <>
        <PartnerSubscriptionExpiredPageNav/>
        <PartnerPricing pricing={"subscriptionExpired"}/>
    </>
  )
}

export default PartnerSubscriptionExpired